import actions from "./actions";
import { ApiCallParams } from "@/services/baseService";
import {
  FriendInviteCreateVm,
  postInviteFriendDataApi
} from "@/services/invites";

export default {
  actions: {
    async [actions.POST_INVITE_FRIEND_DATA](
      ctx?: any,
      params?: ApiCallParams<FriendInviteCreateVm>
    ) {
      if (params !== undefined) {
        await postInviteFriendDataApi(params);
        ctx.commit(
          "updateIsSendingInvitationEmailButtonLoadingMutation",
          false
        );
      }
    }
  },
  state: {}
};
